import { MetricsData, RawMetricsData } from './types';

const coalesce = <T>(
  primary: T | undefined,
  fallback: T | undefined,
  defaultVal: T = 0 as T
): T => primary ?? fallback ?? defaultVal;

export function normalizeMetricsData(data: RawMetricsData): MetricsData {
  const {
    aggregatedMetrics: rawAm,
    dashboardMetrics: rawDashboardMetrics,
    platform: rawPlatformMetrics,
    trends: rawTrendMetrics,
  } = data;

  const aggregatedMetrics: MetricsData['aggregatedMetrics'] = {
    optimizedAdgroups: coalesce(rawAm.optimizedAdgroups, rawAm.optimizedAdsets),
    optimizedAdgroupsCpm: coalesce(
      rawAm.optimizedAdgroupsCpm,
      rawAm.optimizedAdsetsCpm
    ),
    optimizedAdgroupsPerc: coalesce(
      rawAm.optimizedAdgroupsPerc,
      rawAm.optimizedAdsetsPerc
    ),
    optimizedAdgroupsSpend: coalesce(
      rawAm.optimizedAdgroupsSpend,
      rawAm.optimizedAdsetsSpend
    ),
    optimizedAdgroupsSpendPerc: coalesce(
      rawAm.optimizedAdgroupsSpendPerc,
      rawAm.optimizedAdsetsSpendPerc
    ),
    totalAdgroups: coalesce(rawAm.totalAdgroups, rawAm.totalAdsets),
    totalSpend: rawAm.totalSpend,
  };

  const platform: MetricsData['platform'] = rawPlatformMetrics.map(
    (platform) => ({
      CPM: platform.CPM,
      eligibility: platform.eligibility,
      impressions: platform.impressions,
      spend: platform.spend,
      noOfAdGroups: platform.noOfAdGroups ?? platform.noOfAdSets ?? 0,
    })
  );

  const trends: MetricsData['trends'] = rawTrendMetrics.map((t) => ({
    date: t.date,
    eligibleAdgroupsCpm: coalesce(t.eligibleAdgroupsCpm, t.eligibleAdsetsCpm),
    optimizedAdgroupsCpm: coalesce(
      t.optimizedAdgroupsCpm,
      t.optimizedAdsetsCpm
    ),
    optimizedAdgroupsPerc: coalesce(
      t.optimizedAdgroupsPerc,
      t.optimizedAdsetsPerc
    ),
    optimizedAdgroupsSpendPerc: coalesce(
      t.optimizedAdgroupsSpendPerc,
      t.optimizedAdsetSpendPerc
    ),
  }));

  return {
    aggregatedMetrics,
    dashboardMetrics: rawDashboardMetrics,
    platform,
    trends,
  };
}
